/* eslint-disable import/no-unresolved */
import ReportConfigDetails from 'views/Rules/common/ReportConfigDetails';

const Metro2ReportConfigDetails = ({
    commonMetro2Data, selectedMetro2Quarter, setSelectedMetro2Quarter,
}) => (
    <ReportConfigDetails
        istopier="No"
        displayColumn="Yes"
        commonData={commonMetro2Data}
        selectedQuarter={selectedMetro2Quarter}
        setSelectedQuarter={setSelectedMetro2Quarter}
        rule="Metro2"
    />
);

export default Metro2ReportConfigDetails;
